/* Ship-by date in the cart (snippets/cart-stock-note-gp.liquid). Liquid
   renders the lead time ("ships in about 3 weeks") and a template holding
   [date]; this swaps the date in, so the date is never baked into a cached
   page. A custom element, so a re-rendered cart drawer fills itself in.

   The date rule matches assets/product-form-gp.js's shipByDate(): today in
   the studio's time zone plus the lead time in calendar days, moved on to the
   Monday when it lands on a weekend. Change one, change both.

   Each note that comes or goes also rewrites the Pre-orders cart attribute
   (one entry per line, "Title (2 pre-orders: ships by 2 Nov)"), so the
   admin order says what is made to order. Cleared when no note is left. */
class ShipByGp extends HTMLElement {
  connectedCallback() {
    const days = Number(this.dataset.days);
    const template = this.dataset.template;
    if (template && Number.isFinite(days)) {
      this.textContent = template.replace('[date]', ShipByGp.format(ShipByGp.date(days)));
    }
    if (this.dataset.attribute) ShipByGp.attribute = this.dataset.attribute;
    ShipByGp.schedule();
  }

  disconnectedCallback() {
    ShipByGp.schedule();
  }

  /* A cart re-render swaps every note at once; one sync after it settles. */
  static schedule() {
    clearTimeout(ShipByGp.timer);
    ShipByGp.timer = setTimeout(() => ShipByGp.sync(), 300);
  }

  static async sync() {
    const name = ShipByGp.attribute;
    if (!name || !window.routes) return;
    /* Keyed by line, since the cart page and the drawer can both hold it. */
    const lines = new Map();
    document.querySelectorAll('ship-by-gp[data-key]').forEach((el) => {
      lines.set(el.dataset.key, `${el.dataset.label} (${el.textContent.trim()})`);
    });
    const value = Array.from(lines.values()).join('; ');
    try {
      if (ShipByGp.sent === undefined) {
        const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
        ShipByGp.sent = (cart.attributes && cart.attributes[name]) || '';
      }
      if (value === ShipByGp.sent) return;
      ShipByGp.sent = value;
      await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [name]: value } }),
      });
    } catch (e) {
      ShipByGp.sent = undefined;
    }
  }

  static date(days) {
    const today = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date());
    const [y, m, d] = today.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d + days, 12));
    const weekday = date.getUTCDay();
    if (weekday === 6) date.setUTCDate(date.getUTCDate() + 2);
    if (weekday === 0) date.setUTCDate(date.getUTCDate() + 1);
    return date;
  }

  /* "2 Nov": short month, so the cart line stays on one row. */
  static format(date) {
    return new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', day: 'numeric', month: 'short' }).format(date);
  }
}

if (!customElements.get('ship-by-gp')) {
  customElements.define('ship-by-gp', ShipByGp);
}
